// extracted by mini-css-extract-plugin
module.exports = {"Container":"IconHeader__Container___1JkfY","Text":"IconHeader__Text___cSLfk","Icon":"IconHeader__Icon___jXo0L"};